<div class="not-found-container">
  <div class="not-found-content">
    <h1 class="error-code">Error</h1>
    <p class="error-message">
      The page you are looking for is not found. This may be because the link is invalid or has
      expired.
    </p>
  </div>
</div>
